import {IAuthToken, IInputLogin, IInputPassword, IUser} from 'MyModels';

import {createAction, createAsyncAction} from 'typesafe-actions';

export const setUser = createAction('@AUTH/SET_USER')<IUser>();

export const loadUserAsync = createAsyncAction(
  '@AUTH/LOAD_USER_REQUEST',
  '@AUTH/LOAD_USER_SUCCESS',
  '@AUTH/LOAD_USER_FAILURE'
)<void, void, string>();

export const setAuthToken = createAction('@AUTH/SET_TOKEN')<IAuthToken>();

export const logoutAuthAsync = createAsyncAction(
  '@AUTH/LOGOUT_REQUEST',
  '@AUTH/LOGOUT_SUCCESS',
  '@AUTH/LOGOUT_FAILURE'
)<void, void, string>();

export const loginAuthAsync = createAsyncAction(
  '@AUTH/LOGIN_REQUEST',
  '@AUTH/LOGIN_SUCCESS',
  '@AUTH/LOGIN_FAILURE'
)<IInputLogin, IAuthToken, string>();

export const updatePwdAsync = createAsyncAction(
  '@AUTH/CHANGE_PWD_REQUEST',
  '@AUTH/CHANGE_PWD_SUCCESS',
  '@AUTH/CHANGE_PWD_FAILURE'
)<IInputPassword, void, string>();



// WEBPACK FOOTER //
// ./src/features/auth/store/actions.ts